import { EShipping } from '@/src/types/common/discount';
import { get } from 'lodash';
import React from 'react';
import {
  Form,
  OriCheckbox,
  OriNumberInput,
  RadioGroup,
  RadioItem,
} from 'src/components/Antd';
import { useI18n } from 'src/hooks/useRouterChange';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import { isNumber } from 'src/tools/helper';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';
const Item = Form.Item;

const _base = 'discountMethod';
const scope = [_base, 'shippingDiscountType'];
const maxDeductionEnabled = [_base, 'maxDeductionEnabled'];
const maxDeduction = [_base, 'maxDeduction'];
const fixedAmount = [_base, 'fixedAmount'];

const ShippingDiscountValue = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { currency, form, disableEdit } = props;
  return (
    <SectionWrapper
      containerClassName={`${css.sectionContainer} ${css.sectionContainerWeights}`}
      title={getI18n('salesChannelDirectDiscount.discountValue.discountValue')}>
      <Item
        name={scope}
        rules={[
          { required: true, message: getI18n('general.pleaseselectavalue') },
        ]}>
        <RadioGroup className={css.radioGroup} disabled={disableEdit}>
          <RadioItem className={css.radio} value={EShipping.Free}>
            {getI18n(
              'salesChannelDirectDiscount.discountValuebuyOne.freeShipping',
            )}
          </RadioItem>
          <Item
            shouldUpdate={(p, c) => {
              const pV = get(p, scope);
              const cV = get(c, scope);
              return pV !== cV;
            }}>
            {({ getFieldValue }) => {
              const shouldDisplay = getFieldValue(scope) === EShipping.Free;
              if (shouldDisplay) {
                return (
                  <div className={css.exclusiveContainer}>
                    <Item name={maxDeductionEnabled} valuePropName={'checked'}>
                      <OriCheckbox
                        className={css.checkbox}
                        disabled={disableEdit}>
                        {getI18n(
                          'salesChannelDirectDiscount.discountValuebuyOne.excludeshippingrateover',
                        )}
                      </OriCheckbox>
                    </Item>
                    <Item
                      shouldUpdate={(p, c) => {
                        const pV = get(p, maxDeductionEnabled);
                        const cV = get(c, maxDeductionEnabled);
                        return pV !== cV;
                      }}>
                      {({ getFieldValue }) => {
                        const isDisable = !getFieldValue(maxDeductionEnabled);
                        setTimeout(() => {
                          if (isDisable) {
                            form.setFields([
                              { name: maxDeduction, errors: [] },
                            ]);
                          }
                          // form.validateFields([maxDeduction]);
                        });

                        if (isDisable) {
                          return (
                            <Item name={maxDeduction}>
                              <OriNumberInput
                                disabled={true}
                                size='large'
                                suffix={currency}
                                precision={2}
                                className={css.numberInput}
                              />
                            </Item>
                          );
                        }
                        return (
                          <Item
                            name={maxDeduction}
                            rules={[
                              {
                                validator: async (x, value) => {
                                  if (!isDisable) {
                                    if (!isNumber(value)) {
                                      return Promise.reject(
                                        new Error(
                                          getI18n(
                                            'general.pleasefillthisfield',
                                          ),
                                        ),
                                      );
                                    }
                                    if (value < 1) {
                                      return Promise.reject(
                                        new Error(
                                          `${getI18n('general.noLessThan')} 1`,
                                        ),
                                      );
                                    }
                                  }
                                },
                              },
                            ]}>
                            <OriNumberInput
                              //disabled={isDisable}
                              disabled={disableEdit}
                              size='large'
                              suffix={currency}
                              precision={2}
                              className={css.numberInput}
                            />
                          </Item>
                        );
                      }}
                    </Item>
                  </div>
                );
              }
              return null;
            }}
          </Item>
          <RadioItem value={EShipping.Fixed}>
            {getI18n('salesChannelDirectDiscount.type.fixedReductionAmount')}
          </RadioItem>
          <Item
            className={css.fixedContainer}
            shouldUpdate={(p, c) => {
              const pV = get(p, scope);
              const cV = get(c, scope);
              return pV !== cV;
            }}>
            {({ getFieldValue }) => {
              const isDisplay = getFieldValue(scope) === EShipping.Fixed;
              if (isDisplay) {
                return (
                  <Item
                    name={fixedAmount}
                    rules={[
                      {
                        validator: async (x, value) => {
                          if (!isNumber(value)) {
                            return Promise.reject(
                              new Error(getI18n('general.pleasefillthisfield')),
                            );
                          }
                          if (value < 1) {
                            return Promise.reject(
                              new Error(`${getI18n('general.noLessThan')} 1`),
                            );
                          }
                        },
                      },
                    ]}>
                    <OriNumberInput
                      size='large'
                      suffix={currency}
                      className={css.numberInput1}
                      disabled={disableEdit}
                    />
                  </Item>
                );
              }
              return null;
            }}
          </Item>
        </RadioGroup>
      </Item>
    </SectionWrapper>
  );
};
export default ShippingDiscountValue;
